import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Cookies } from 'react-cookie';
import Modal from '../../../commonComponents/modal/Modal';
import LoginPhase from './loginIn/LoginPhase';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import GoogleAnalytics from '../../../services/googleAnalytics';
import ConfigsContext from '../../../contextProviders/ConfigsContext';

const PHASE = { LOGIN: 'login', WIZARD: 'wizard', PLANS: 'plans' };

export default function LoginModal({
  languages,
  logo,
  redirectLink,
  onClose,
  showRegisterAccount,
  onLoggedIn,
  ignoreRedirection,
  cookies,
}) {
  const [phase, setPhase] = useState(PHASE.LOGIN);
  const { organization } = useContext(ConfigsContext);
  const openTheSelectSponsorModal =
    organization?.settings?.roundMeDistributors?.enabled;

  const handleSignUp = () => {
    GoogleAnalytics.accountCreated(!redirectLink);
    const url = redirectLink || '/';
    window.location.href = openTheSelectSponsorModal
      ? `${url}?openSponsor=true`
      : url;
  };

  const handleClose = () => {
    document.querySelector('.modal-backdrop').remove();
    onClose();
  };

  const modalClasses = cx(
    'modal-base',
    'modal-dialog-centered',
    { 'login-modal': phase === PHASE.LOGIN },
    { 'course-wizard-modal': phase === PHASE.WIZARD },
  );

  return (
    <>
      <Modal onClose={onClose}>
        <div className={modalClasses} role="document">
          <div className="modal-content">
            <div id="modalBody" className="modal-body">
              {phase === PHASE.LOGIN && (
                <LoginPhase
                  logo={logo}
                  languages={languages}
                  onSignUpComplete={handleSignUp}
                  redirectLink={redirectLink}
                  onClose={handleClose}
                  showRegisterAccount={showRegisterAccount}
                  onLoggedIn={onLoggedIn}
                  ignoreRedirection={ignoreRedirection}
                  cookies={cookies}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

LoginModal.propTypes = {
  tenant: PropTypes.shape({}).isRequired,
  redirectLink: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  showRegisterAccount: PropTypes.bool,
  onLoggedIn: PropTypes.func,
  ignoreRedirection: PropTypes.bool,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};

LoginModal.defaultProps = {
  showRegisterAccount: true,
  onLoggedIn: null,
  ignoreRedirection: false,
};
